export const DOC_CAMPAIGNS_BY_USER = "campaigns_by_user";
export const DOC_CAMPAIGNS = "campaigns";

export const DOC_PROFILE = "profile";
